'use es6';

import PropTypes from 'prop-types';
import { isResolved } from 'reference-resolvers/utils';
import BusinessUnitTag from 'ui-business-units-lib/components/BusinessUnitTag';
import { mapReferenceResolverToPlainJS, provideBusinessUnitDropdown } from '../../../utils/businessUnitUtils';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessUnitCell = ({
  buId
}) => {
  const BusinessUnitWrapper = provideBusinessUnitDropdown(({
    buOptions
  }) => {
    var _buOptions$find;
    const _buOptions = mapReferenceResolverToPlainJS(buOptions);
    const buName = (_buOptions$find = _buOptions.find(bu => bu.id === buId)) === null || _buOptions$find === void 0 ? void 0 : _buOptions$find.name;
    if (isResolved(_buOptions) && _buOptions.length !== 0) {
      return /*#__PURE__*/_jsx("td", {
        children: /*#__PURE__*/_jsxs(TFlex, {
          gap: 8,
          align: "center",
          justify: "start",
          children: [/*#__PURE__*/_jsx(BusinessUnitTag, {
            buId: buId,
            buOptions: _buOptions,
            noBorder: true,
            truncateLength: 112,
            size: "xs",
            numFramesToDefer: 2,
            onlyLogo: true
          }), /*#__PURE__*/_jsx(TruncateString, {
            maxWidth: 84,
            title: buName,
            children: buName
          })]
        })
      });
    } else {
      return null;
    }
  });
  return /*#__PURE__*/_jsx(BusinessUnitWrapper, {});
};
BusinessUnitCell.propTypes = {
  buId: PropTypes.number.isRequired
};
export default BusinessUnitCell;